import { fetchOptins } from '@/api/insuranceApi';
import { LocalStorageService } from '@/core/services/localStorageService';

const CHECKOUT_OPTINS_KEY = 'optins';

export const NEWSLETTER_OPTIN_IDENTIFIER = 'newsletter';

export const OptinsService = () => {
    const set = (optins) => {
        LocalStorageService.set(CHECKOUT_OPTINS_KEY, optins)
    }

    const get = () => {
        return LocalStorageService.get(CHECKOUT_OPTINS_KEY)
    }

    const getCompaniesNames = (selectedProduct, quote) => {
        const companies = new Set();
        for(const cover of selectedProduct.covers) {
            if (!cover.data.frontEndProperties.isInPrimaryProduct) {
                companies.add(`${cover.data.frontEndProperties.vendorName} (${cover.data.name})`);
                continue;
            }

            companies.add(selectedProduct.company.name)
        }

        for (const upsell of selectedProduct.availableToAddCovers) {
            if (!quote.insuranceCovers.includes(upsell.type?.guid)) {
                continue;
            }
            
            if (!upsell.frontEndProperties.isInPrimaryProduct) {
                companies.add(`${upsell.frontEndProperties.vendorName} (${upsell.name})`);
                continue;
            }
        }

        return [...companies].join(', ');
    }


    const getOptins = async (quote, easyBuy, vendor, primaryProduct, selectedProduct, name) => {
        const companies = getCompaniesNames(selectedProduct, quote);
        const optinsRequest = {
            quote: {
                "packet": quote.insuranceType,
                "easyBuy": `${easyBuy}`,
                "classificationType": quote.vehicleType,
            },
            details: {
                "vendorGuid": vendor.guid,
                "productGuid": primaryProduct.guid,
                "multiproduct": {
                    "name": name,
                    "primaryProduct": {
                        "guid": primaryProduct.guid,
                        "name": primaryProduct.name,
                    }
                },
                products: selectedProduct.payload.multiproduct.products.map(p => ({
                    "guid": p.guid,
                    "name": p.name,
                    "vendor": {
                        "name": p.vendor.name,
                        "guid": p.vendor.guid,
                        "siteId": p.vendor.attributes.siteId,
                    }
                })),
                attributes: {
                    "crmId": selectedProduct.payload.multiproduct.attributes.crmId,
                    "easyBuy": `${easyBuy}`,
                }
            },
            screenName: 'checkout',
            data: {
                companies: companies,
            }
        }

        const optins = await fetchOptins(optinsRequest);
        return optins
    }

    return {
        set,
        get,
        getOptins,
    }
}